// @flow

/**
 * URL absoluta de una imagen de Finect a partir de su ruta, o `undefined` si no hay ruta.
 *
 * El `undefined` es la gracia del asunto. Pegarle el dominio a una ruta ausente fabricaba
 * "https://www.finect.comundefined": el navegador lo lee como un dominio, no lo resuelve y deja un
 * "net::ERR_NAME_NOT_RESOLVED" en la consola de cada visita. Los componentes que pintan avatares
 * (<Icon>, <EntityCard>) ya saben qué hacer cuando no les llega imagen: pintan la suya por defecto.
 * Lo que no saben es distinguir una URL rota de una buena, porque una cadena siempre les parece
 * válida.
 *
 * Una ruta que ya sea absoluta se devuelve tal cual, para no anteponerle el dominio dos veces.
 */
export const getAbsoluteImageURL = (path: ?string): string | void => {
  if (!path) return undefined;
  if (/^(https?:)?\/\//i.test(path)) return path;

  return `https://${process.env.FINECT_BASEURL || 'www.finect.com'}${path}`;
};
